<template>
  <div id="wrapper">
    <sidebar-menu />
    <div id="content-wrapper" class="d-flex flex-column">
      <div id="content">
        <top-bar-menu />
        <div class="container-fluid" id="container-wrapper">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import NavMenu from "@/components/NavMenu.vue";
import TopBarMenu from "@/components/TopBarMenu.vue";
import SidebarMenu from "@/components/SidebarMenu.vue";

export default {
  components: {
    // NavMenu,
    TopBarMenu,
    SidebarMenu,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
#inspire {
  .v-application {
    background-color: #ffffe0;
  }
  #app {
    text-align: start;
  }
  .content {
    padding-top: 116.018px;
  }
  @media (max-width: 768px) {
    .content {
      padding-top: 35px;
      padding-left: 25px;
      padding-right: 25px;
    }
  }
  @media (min-width: 1000px) {
    .container--fluid {
      width: 980px;
    }
  }
}
</style>
